import { authHeader, handleResponse } from '../helpers';
export const TertiaryPackingRptService = {
    fetchTertiaryData   
};

function fetchTertiaryData(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };

    return fetch(`${process.env.REACT_APP_API_URL}TertiaryPackingRpt/GetTertiaryReport`, requestOptions)
        .then(handleResponse);
}